import { type ActionArgs } from 'xstate5';

import { type OrderingContext } from './ordering-machine.context';
import { type OrderingEvent } from './ordering-machine.events';

// ─────────────────────────────────────────────────────────────────────────────

const wantedTimesPolling: Delay = ({ context }) => context.wantedTimesPollingInterval; // prettier-ignore
const bagCartPolling: Delay = ({ context }) => context.bagCartPollingInterval;
const postOrderDelay: Delay = ({ context }) => context.postOrderDelay;
const orderSubmissionDelay: Delay = ({ context }) => context.orderSubmissionDelay; // prettier-ignore

// ─────────────────────────────────────────────────────────────────────────────

export const OrderingDelays = {
  wantedTimesPolling,
  bagCartPolling,
  postOrderDelay,
  orderSubmissionDelay,
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Delay = (args: ActionArgs<OrderingContext, OrderingEvent, OrderingEvent>) => number;
